import React from "react";
import { useParams } from "react-router-dom";
import WayfinderLayout from "./WayfinderLayout";
import GlobalWayfinderButtonSettings from "./GlobalWayfinderButtonSettings";

const GlobalPage = ({ buttonColor }) => {
  const { userId } = useParams();
  return <GlobalWayfinderButtonSettings userId={userId} buttonColor={buttonColor} />;
};

// Wrap with layout
const GlobalPageWithLayout = () => (
  <WayfinderLayout>
    <GlobalPage />
  </WayfinderLayout>
);

export default GlobalPageWithLayout;
